export default "__VITE_ASSET__DsiIydrg__"